var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3C4.22386 3 4 3.22386 4 3.5V20.5008C4 20.7769 4.22386 21.0008 4.5 21.0008H19.501C19.7772 21.0008 20.001 20.7769 20.001 20.5008V3.5C20.001 3.22386 19.7772 3 19.501 3H4.5ZM5 20.0008V4H19.001V20.0008H5ZM8.24972 14.0508C7.97358 14.0508 7.74972 14.2746 7.74972 14.5508C7.74972 14.8269 7.97358 15.0508 8.24972 15.0508H14.8141C15.0903 15.0508 15.3141 14.8269 15.3141 14.5508C15.3141 14.2746 15.0903 14.0508 14.8141 14.0508H8.24972ZM7.74972 17.1006C7.74972 16.8244 7.97358 16.6006 8.24972 16.6006H11.5312C11.8074 16.6006 12.0312 16.8244 12.0312 17.1006C12.0312 17.3767 11.8074 17.6006 11.5312 17.6006H8.24972C7.97358 17.6006 7.74972 17.3767 7.74972 17.1006ZM8.24972 6.40039C7.97358 6.40039 7.74972 6.62425 7.74972 6.90039V11.1509C7.74972 11.427 7.97358 11.6509 8.24972 11.6509H14.8141C15.0903 11.6509 15.3141 11.427 15.3141 11.1509V6.90039C15.3141 6.62425 15.0903 6.40039 14.8141 6.40039H8.24972ZM8.74972 10.6509V7.40039H14.3141V10.6509H8.74972Z",
    fill: "#A09B97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnership);
export default __webpack_public_path__ + "static/media/ownership.77a6bc022bce7269b0e2c555a1fd95ea.svg";
export { ForwardRef as ReactComponent };